import cookie from "js-cookie"

/**
 * Клиент аутинтификации
 */
export default class AuthClient {
	static CHECK_TOKEN_INTERVAL = 500

	// Ключ под которым хранится
	static KEY_TOKEN = "auth_token"

	/**
	 * Инициализировать клиент
	 * @param {Object} config
	 */
	constructor(config) {
		config = config || {}

		this.rules = config.rules || {}
		this.domain = config.domain || null
		this.handlers = []
		this.user = {}

		// Предыдущее состояние токена
		this.prevToken = this.getToken()

		// Установить слушетеля изменений токена
		this.setTokenListener()
	}

	/**
	 * Токен пользователя
	 */
	get token() {
		return this.getToken()
	}

	/**
	 * Установить слушетеля изменений токена
	 */
	setTokenListener() {
		// Периодически проверять состояние токена
		setInterval(async () => {
			// console.log({ prevToken: this.prevToken, token: this.token })

			// Если состояние отличается
			if (this.prevToken !== this.token) {
				this.prevToken = this.token

				// Вызвать обработчики изменения токена
				for (const handler of this.handlers) {
					await handler.call(null, this)
				}
			}
		}, AuthClient.CHECK_TOKEN_INTERVAL)
	}

	/**
	 * Установить обработчика изменений токена
	 * @param {Function} handler
	 */
	onChangeToken(handler) {
		this.handlers.push(handler)
	}

	/**
	 * Проверить пользоватлея по правилу
	 * @param {String} name
	 * @param {Object|null} params
	 * @return {Boolean}
	 */
	is(name, params) {
		const rule = this.rules[name]

		if (rule instanceof Function) {
			params = params || {}

			return rule.call(null, this, params)
		}

		return false
	}

	/**
	 * Получить токен пользователя
	 * @return {String|null}
	 */
	getToken() {
		return cookie.get(AuthClient.KEY_TOKEN) || null
	}

	/**
	 * Установить токен пользователя
	 * @param {String} token
	 */
	setToken(token) {
		this.prevToken = token

		cookie.set(AuthClient.KEY_TOKEN, token, { domain: this.domain })
	}

	/**
	 * Снять токен пользователя
	 */
	unsetToken() {
		this.prevToken = null

		cookie.remove(AuthClient.KEY_TOKEN, { domain: this.domain })
	}

	/**
	 * Получить пользователя
	 * @return {Object}
	 */
	getUser() {
		return this.user
	}

	/**
	 * Установить пользователя
	 * @param {Object} user
	 */
	setUser(user) {
		this.user = user
		this.setToken(user.token)
	}

	/**
	 * Снять установленного пользователя
	 */
	unsetUser() {
		this.user = {}
		this.unsetToken()
	}
}
